import {
    CellEventType,
    CellRenderContext,
    IGridCellRenderer
} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridModel';
import {TextCell} from '@mintdata-wsp/wsp/ui/components/grid/cells/TextCell';
import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('./TextCell.less');
const cx = classnames.bind(styles);

export class TextCellRenderer implements IGridCellRenderer
{
    render(ctx:CellRenderContext):React.ReactElement<any>
    {
        const aCell = ctx.cell as TextCell;

        return <span key={ctx.key}
                     style={ctx.style}
                     className={cx('textCell',
                                   ctx.className)}
                     ref={ctx.ref}
                     onClick={()=>{ctx.onCellEvent(CellEventType.Clicked)}}>
                        {aCell.text}
                </span>;
    }
}
